import FastAPIClient from "../../client";
import config from "../../config";
const client = new FastAPIClient(config);

export const handleCreateClient = (clientData) => {
    const updatedClientData = {
        ...clientData,
        address_1: clientData.adresse,
        client_name_full: clientData.client_name,
    };
    delete updatedClientData.adresse;
    const createdClient = client.createClient(updatedClientData);
    return createdClient;
};

export const getCounts = (
    user_id,
    filter,
    status_filter,
    visit_days,
    showLeads,
    clientCount,
    setClientCount,
    setLeadCount
) => {
    const countClients = () => {
        client
            .getClientCount(
                {
                    user_id,
                    is_lead: false,
                },
                { filter, status_filter, visit_days }
            )
            .then((data) => {
                setClientCount(data);
            });
    };
    const countLeads = () => {
        client
            .getClientCount(
                {
                    user_id,
                    is_lead: true,
                },
                { filter, status_filter, visit_days }
            )
            .then((data) => {
                setLeadCount(data);
            });
    };
    if (!clientCount) {
        countClients();
        countLeads();
    }
    if (showLeads) {
        countLeads();
    } else {
        countClients();
    }
};

export const filterOffline = (
    allClients,
    showLeads,
    selectedFilters,
    statusFilters,
    daysFilters,
    sortOption,
    setClients,
    setLeadCount,
    setClientCount
) => {
    let results = allClients;

    results = results.filter((client) => client.is_lead === showLeads);

    if (Object.keys(selectedFilters).length > 0) {
        results = results.filter((client) => {
            for (const [key, selectedValues] of Object.entries(
                selectedFilters
            ) as [string, string[]][]) {
                if (selectedValues.length === 0) continue;
                if (!selectedValues.includes(client[key])) {
                    return false;
                }
            }
            return true;
        });
    }

    // Apply status filters
    if (statusFilters && Object.keys(statusFilters).length > 0) {
        results = results.filter((client) => {
            for (const [key, selectedValues] of Object.entries(
                statusFilters
            ) as [string, boolean[]][]) {
                if (selectedValues.length === 0) continue;
                if (!selectedValues.includes(client[key])) {
                    return false;
                }
            }
            return true;
        });
    }

    // Apply days filters
    if (daysFilters && daysFilters.length > 0) {
        results = results.filter((client) => {
            return daysFilters.includes(client.visit_days);
        });
    }

    // Sort results based on sortOption
    if (sortOption) {
        if (sortOption === "name_asc") {
            results = results.sort((a, b) =>
                a.client_name.localeCompare(b.client_name)
            );
        } else if (sortOption === "name_desc") {
            results = results.sort((a, b) =>
                b.client_name.localeCompare(a.client_name)
            );
        } else if (sortOption === "alert_asc") {
            results = results.sort((a, b) => a.alert - b.alert);
        } else if (sortOption === "alert_desc") {
            results = results.sort((a, b) => b.alert - a.alert);
        } else if (sortOption === "last_meeting_start_date_asc") {
            results = results.sort((a, b) => {
                if (!a.last_meeting_start_date && !b.last_meeting_start_date)
                    return 0;
                if (!a.last_meeting_start_date) return 1;
                if (!b.last_meeting_start_date) return -1;
                const dateA = new Date(a.last_meeting_start_date).getTime();
                const dateB = new Date(b.last_meeting_start_date).getTime();
                return dateA - dateB;
            });
        } else if (sortOption === "last_meeting_start_date_desc") {
            results = results.sort((a, b) => {
                if (!a.last_meeting_start_date && !b.last_meeting_start_date)
                    return 0;
                if (!a.last_meeting_start_date) return 1;
                if (!b.last_meeting_start_date) return -1;
                const dateA = new Date(a.last_meeting_start_date).getTime();
                const dateB = new Date(b.last_meeting_start_date).getTime();
                return dateB - dateA;
            });
        }
    } else {
        // Default sort by alert status if no sort option is selected
        results = results.sort((a, b) => b.alert - a.alert);
    }

    setClients(results);
    if (showLeads) {
        setLeadCount(results.length);
    } else {
        setClientCount(results.length);
    }

    return results;
};
